module.exports = __webpack_public_path__ + "assets/images/ll-upsell-bg-8ea0011fe4f54b59da36ab9204c61f09.png";